import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cookieUtils from './utils/cookie'

Vue.config.productionTip = false
Vue.use(ElementUI);

// 注册全局cookie工具
Vue.prototype.$cookie = cookieUtils;

// 调试用：自动设置JSESSIONID cookie
if (process.env.NODE_ENV === 'development') {
  cookieUtils.setCookie('JSESSIONID', '16F1B97CCD6DA417C2E7B7E596182780');
  console.log('✓ 开发环境已自动设置JSESSIONID cookie');
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
